// mixins/formDirtyMixin.js
export default {
  data() {
    return {
      isFormDirty: false,
    };
  },
  methods: {
    markDirty() {
      this.isFormDirty = true;
    },
    resetDirty() {
      this.isFormDirty = false;
    },
    async confirmLeave() {
      const result = await this.$swal({
        title: "You have unsaved changes.",
        text: "Are you sure you want to leave this tab?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Confirm",
        cancelButtonText: "Cancel",
      });
      return result.isConfirmed;
    },
    beforeUnloadListener(event) {
      if (this.isFormDirty) {
        event.preventDefault();
        event.returnValue = "";
        return "";
      }
    },
    async handleTabSwitch(newTabIndex, cancelCallback) {
      if (!this.isFormDirty) return true;

      const confirmed = await this.confirmLeave();
      if (confirmed) {
        this.resetDirty();
        return true;
      } else {
        if (cancelCallback) cancelCallback();
        return false;
      }
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isFormDirty) {
      this.confirmLeave().then((confirmed) => {
        if (confirmed) {
          this.resetDirty();
          next();
        } else {
          next(false);
        }
      });
    } else {
      next();
    }
  },
  mounted() {
    window.addEventListener("beforeunload", this.beforeUnloadListener);
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.beforeUnloadListener);
  },
};
